__turbopack_context__.v({
  "faqAccordionControls": "FW0hiG_faqAccordionControls",
  "faqSectionContainer": "FW0hiG_faqSectionContainer",
  "faqSectionHeader": "FW0hiG_faqSectionHeader",
});
